import React from 'react';

export default function CameraPositionLogger({ camera }) {
  const logCameraPosition = () => {
    if (camera) {
      console.log('Camera Position:', camera.position);
    } else {
      console.warn('Camera not ready');
    }
  };

  return (
    <button 
        onClick={logCameraPosition}
        className="btn btn--small btn--primary"
        >
      カメラ位置をログ出力
    </button>
  );
}
